import { Box } from '@mui/material'

export const FormHeaderButton = ({ children }) => {
  return <Box fontSize='1.4rem' textAlign='center'>{children}</Box>
}
